import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Home = () => import("@/views/Home");
const International = () => import("@/views/International");
const Production = () => import("@/views/Production");
const newsInfo = () => import("@/views/newsInfo");
const Intelligent = () => import("@/views/Intelligent");

const Scientific = () => import("@/views/Scientific");
const ThreeNav = () => import("@/views/ThreeNav");
const Investment = () => import("@/views/Investment");
const FourNav = () => import("@/views/FourNav");
const FiveNav = () => import("@/views/FiveNav");
const Demo = () => import("@/views/Demo");
const SeDetail = () => import("@/views/SeDetail");
const WangInfo = () => import("@/views/WangInfo");
const BianPai = () => import("@/views/BianPai");
const collPlatform = () => import("@/views/collPlatform");
const kyDetail = () => import("@/views/kyDetail");
const kyDetail1 = () => import("@/views/kyDetail1");
const copyrightInfo = () => import("@/views/copyrightInfo");
const projectInfo = () => import("@/views/projectInfo");
const rightInfo = () => import("@/views/rightInfo");
const patentInfo = () => import("@/views/patentInfo");
const serviceInfo = () => import("@/views/serviceInfo");
const daqin = () => import("@/views/daqin");
const ProductionBrain = () =>
  import("@/components/production/ProductionBrain.vue");
const IntelService = () => import("@/components/intelligent/IntelService.vue");
const topicresearch = () => import("@/components/scientific/topicresearch.vue");
const experiment = () => import("@/components/scientific/experiment.vue");
const YunZhaoShang = () => import("@/components/yun_zhaoshang/index.vue");
const empowered = () => import("@/components/empowered/index.vue");
const EnterInnovation = () => import("@/components/enter_innovation/index.vue");
const propertyrights = () => import("@/components/propertyrights/index.vue");
const Journal = () => import("@/components/journal/index.vue");
const Online = () => import("@/components/online_literature/index.vue");
const Monograph = () => import("@/components/monograph/index.vue");
const Version = () => import("@/components/version/index.vue");
const Convention = () => import("@/components/convention/index.vue");
const Education = () => import("@/components/education/index.vue");
const Consulting = () => import("@/components/consulting/index.vue");
// const bookInfo = () => import("@/views/bookInfo");
const buyItem = () => import("@/views/buyItem");
const routes = [
  {
    path: "",
    redirect: "/home"
  },
  {
    path: "/home",
    component: Home
  },
  {
    path: "/production",
    component: Production,
    children: [
      {
        path: "1",
        component: ProductionBrain
      },
      {
        path: "2",
        component: YunZhaoShang
      },
      {
        path: "3",
        component: EnterInnovation
      },
      {
        path: "4",
        component: Consulting
      }
    ]
  },
  {
    path: "/international",
    component: International,
    children: [
      {
        path: "1",
        component: Convention
      },
      {
        path: "2",
        component: Education
      },
      {
        path: "3",
        component: propertyrights
      },
      {
        path: "4",
        component: Journal
      },
      {
        path: "5",
        component: Online
      },
      {
        path: "6",
        component: Monograph
      },
      {
        path: "7",
        component: Version
      }
    ]
  },
  {
    path: "/intelligent",
    component: Intelligent,
    children: [
      {
        path: "1",
        component: IntelService
      },
      {
        path: "2",
        component: empowered
      },
      {
        path: "3",
        component: EnterInnovation
      },
      {
        path: "4",
        component: BianPai
      },
      {
        path: "5",
        component: collPlatform
      }
    ]
  },
  {
    path: "/scientific",
    component: Scientific,
    children: [
      {
        path: "1",
        component: experiment
      },
      {
        path: "2",
        component: topicresearch
      },
      {
        path: "3",
        component: EnterInnovation
      },
      {
        path: "4",
        component: Consulting
      }
    ]
  },
  {
    path: "/investment",
    component: Investment
  },
  {
    path: "/threenav",
    component: ThreeNav
  },
  {
    path: "/fivenav",
    component: FiveNav,
    children: [
      {
        path: "1",
        component: resolve =>
          require(["@/components/realize/introduce"], resolve)
      },
      {
        path: "2",
        component: resolve =>
          require(["@/components/realize/contactInfo"], resolve)
      }
    ]
  },
  //se内容
  {
    path: "/SeDetail",
    component: SeDetail
  },
  // //书详情内容
  // {
  //   path: "/bookInfo",
  //   component: bookInfo
  // },
  //购买书内容
  {
    path: "/buyItem",
    component: buyItem
  },
  //网文内容
  {
    path: "/WangInfo",
    component: WangInfo
  },
  //科研内容
  {
    path: "/kyDetail1",
    component: kyDetail1
  },
  //科研内容
  {
    path: "/kyDetail",
    component: kyDetail
  },
  //大秦农夫内容
  {
    path: "/daqin",
    component: daqin
  },
  //商标内容
  {
    path: "/copyrightInfo",
    component: copyrightInfo
  },
  //科研项目申报内容
  {
    path: "/projectInfo",
    component: projectInfo
  },
  //版权内容
  {
    path: "/rightInfo",
    component: rightInfo
  },
  // 专利内容
  {
    path: "/patentInfo",
    component: patentInfo
  },
  //科技服务业务内容
  {
    path: "/serviceInfo",
    component: serviceInfo
  },
  //新闻详情内容news
  {
    path: "/newsInfo",
    component: newsInfo
  },
  {
    path: "/demo",
    component: Demo
  }
];

const router = new VueRouter({
  // mode: "hash",
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js